import { forwardRef, useEffect, useState } from 'react';
// @mui
import { styled } from '@mui/material/styles';
import {
  Container,
  Dialog,
  Slide,
} from '@mui/material';
// sections
import {
  SelfCheckStepper,
  SelfCheckForm,
  SelfCheckEnd,
} from './post/check';
// hooks
import useResponsive from '../../hooks/useResponsive';
import useAuth from '../../hooks/useAuth';
// axios
import axios from '../../utils/axios';

const Transition = forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

const SelfCheckStyle = styled('div')(({ theme }) => ({
  maxWidth: 900,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  padding: theme.spacing(3, 0),
}));


export default function SelfCheckDialog({ isOpen, jobPost, closeDialog }) {
  const smUp = useResponsive('up', 'sm');
  const { user } = useAuth();

  let steps;
  if (jobPost?.detail_role?.can && jobPost?.detail_role?.role !== '브랜드 마케터') {
    steps = ['글자수 확인', '포지션 확인', '업무범위 확인'];
  } else {
    steps = ['글자수 확인', '업무범위 확인'];
  }
  const [checkStep, setCheckStep] = useState(0);

  const enterSelfCheck = async () => {
    try {
      const companyId = user?.employee.company[0].id;
      const jobPostId = jobPost?.id;
      const startData = {
        check_type: 'start',
      };
      if (!companyId) return;
      if (!jobPostId) return;

      const response = await axios.post(
        `/api/company/${companyId}/job-posts/${jobPostId}/self-check/`,
        startData
      );
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    if (isOpen) {
      enterSelfCheck();
      setCheckStep(0);
    }
  }, [isOpen, jobPost]);

  const goNext = async () => {
    setCheckStep(checkStep + 1);
  }

  return (
    <Dialog fullScreen open={isOpen} onClose={closeDialog} TransitionComponent={Transition}>
      <Container sx={{ mt: smUp ? 10 : 0 }}>
        <SelfCheckStyle>
          <SelfCheckStepper steps={steps} step={checkStep} />
          {checkStep < steps.length && (
            <SelfCheckForm jobPost={jobPost} stepName={steps[checkStep]} next={goNext} />
          )}
          {checkStep >= steps.length && (
            <SelfCheckEnd jobPostId={jobPost?.id} done={closeDialog} />
          )}
        </SelfCheckStyle>
      </Container>
    </Dialog>
  )
}
